export default {
  api: {
    url: "https://quizdb.drmyanmar.com",
  },
}
